import { HelpTopic } from '../types';

export const helpTopics: HelpTopic[] = [
  {
    id: 'explorer',
    title: 'Explorer ve sekmeler',
    summary: 'Dosya ağacı, sekmeler ve kirli durum göstergeleri.',
    details: [
      'Sol panelden dosya aç; sekmeler otomatik oluşur ve kirli dosyalar noktayla işaretlenir.',
      'Sağ tık menüsüyle isim değiştir, sil, yeni dosya/klasör ekle.',
      'Filtre kutusuyla dosya ve path içinde ara.',
      'Panelleri başlıktaki sürükleme tutamacından tutup yeniden sırala; bölücülerden genişliklerini ayarla.',
    ],
    tips: ['Kirli dosyayı kapatmadan önce kaydetmeyi unutma; onay ister.'],
  },
  {
    id: 'quick-open',
    title: 'Go to file (⌘/Ctrl+P)',
    summary: 'Hızlı palet ile dosya aç.',
    details: [
      '⌘/Ctrl+P kısayolu ile paleti aç, yazmaya başla.',
      'Ok tuşlarıyla listede gez, Enter ile aç.',
      'Arama hem dosya adı hem path içinde eşleşir (50 sonuç).',
    ],
  },
  {
    id: 'command-palette',
    title: 'Command palette (⇧⌘/Ctrl+P)',
    summary: 'Lint/Test/Build komutlarını paletten çalıştır.',
    details: [
      '⇧⌘/Ctrl+P ile aç, yazdıkça filtrele.',
      'Ok tuşlarıyla gezin, Enter ile komutu çalıştır.',
      'Kapatmak için Esc veya arkaplana tıkla.',
    ],
  },
  {
    id: 'autosave',
    title: 'Autosave & cache',
    summary: 'Otomatik kaydetme ve yerel cache davranışı.',
    details: [
      'Autosave header pill ile aç/kapat; varsayılan açık.',
      '10sn’de bir, sekme değiştirirken ve editor blur olduğunda kirli dosyalar kaydedilir.',
      'Dosya içerikleri ve sekmeler localStorage’da proje bazlı cache’lenir; yazmalar debounce edilir.',
    ],
    tips: ['Autosave kapalıyken manuel Save butonunu kullan.'],
  },
  {
    id: 'preview-build',
    title: 'Preview debounce',
    summary: 'Canlı önizleme build gecikmesi.',
    details: [
      'Kod değişiminden sonra preview build 600ms gecikmeyle tetiklenir.',
      'Hot reload kapalıysa iframe ve bundle serbest bırakılır; performans artar.',
    ],
  },
  {
    id: 'token-refresh',
    title: 'Token yenileme',
    summary: '401 alındığında otomatik token refresh.',
    details: [
      'API istekleri 401 dönerse token otomatik yenilenip istek tekrar denenir.',
      'Token eksikse veya yenilenemezse durum banner’ı hata gösterir.',
    ],
  },
  {
    id: 'editor',
    title: 'Editör kısayolları',
    summary: 'Kaydet, format ve görev çalıştırma.',
    details: [
      'Mod+S ile kaydet, Mod+Shift+F ile format, Mod+Shift+P ile testleri çalıştır.',
      'Katlama okları ile kod bloklarını daralt/aç.',
      'Status bar dosya ve format bilgilerini gösterir.',
    ],
  },
  {
    id: 'preview',
    title: 'Live preview / Sandbox',
    summary: 'Önizleme ve performans kontrolleri.',
    details: [
      'Hot reload açıkken kod değişimi otomatik render edilir.',
      'Hot reload kapalıyken iframe ve ağ istekleri kapatılır; gerekirse Restart preview ile yenile.',
      'Sandbox toggle ile iframe izinlerini kontrol et.',
      'Device presets (Desktop/Tablet/Mobile) veya Custom slider ile iframe boyutunu ayarla.',
      'Hot reload pill butonu açıkken gerçek bir preview refresh tetikler.',
    ],
    tips: ['Önizleme hatası alırsan Restart preview ile temiz başlat.'],
  },
  {
    id: 'tasks',
    title: 'Görevler ve loglar',
    summary: 'Lint/test/build entegrasyonu.',
    details: [
      'Console kartından Lint/Test/Build komutlarını çalıştır.',
      'Sonuçlar ve API logları console listesinde tutulur.',
      'Commit formu ile üst bardan mesaj girip logla.',
      'Log satırlarında path:line:column içerenler tıklanınca editörde ilgili satıra gider; lint uyarıları gutter/tooltip ile görünür.',
      'Console panelindeki Lint/Test/Build butonları görevleri tetikler, durumlar üst barda görünür.',
      'Log filtresi (All/Info/Error/Success) ile çıktıları daralt.',
      'Konum içeren log satırları buton gibi tıklanabilir ve klavye (Enter/Space) ile çalışır.',
      'Console/Terminal sekmeleri arasında geçiş yaparak terminal görünümünde log akışını izleyebilirsin.',
      'Git diff paneli aktif dosya için kaydedilen içerik ile mevcut çalışma kopyası arasındaki farkları gösterir.',
    ],
  },
  {
    id: 'projects',
    title: 'Projeler ve branch',
    summary: 'Çoklu proje/branch seçimi ve önbellek.',
    details: [
      'Header’daki açılır menülerden aktif proje ve branch’i değiştir.',
      'Project ID override inputu ile başka projelere geçip debug edebilirsin.',
      'API base/key/secret alanları header’dan düzenlenir, 401 alınca token otomatik yenilenir.',
      'Settings export/import ile JSON dosyasından IDE ayarlarını taşıyabilirsin.',
      'Önbellek temizleme butonu yerel dosya cache’ini sıfırlar; Reload project, API’den ağaç ve içerikleri tazeler.',
      'Autosave ve Clear cache kontrolleri üst barda; Clear cache tüm localStorage cache’lerini temizler.',
    ],
  },
  {
    id: 'editor-meta',
    title: 'Editör meta ayarları',
    summary: 'Kodlayıcı meta bilgiler ve göstergeler.',
    details: [
      'Status barda encoding ve indentation bilgileri dinamik gösterilir.',
      'Indent (2/4/8 space) ve encoding (UTF-8 vb.) dropdownlarıyla değiştirilebilir.',
      'Terminator ikonlu tablo; dosya/folder ikonları Explorer’da görsel ayrım sağlar.',
    ],
  },
  {
    id: 'settings',
    title: 'Ayarlar & aktarım',
    summary: 'API/Project kimlik bilgileri ve ayar transferi.',
    details: [
      'API_BASE / API_KEY / API_SECRET değerlerini header’daki girişlerden güncelle, otomatik kaydolur.',
      'Project ID override kutusuyla hızlıca farklı projeye bağlan.',
      'Export settings ile atlas-settings.json indir, Import settings ile başka ortamda yükle.',
      'Panel genişlikleri, preview device, autosave gibi ayarlar export dosyasına dahildir.',
    ],
  },
];
